<template>
  <div>
    <div class="row">
      <div class="col-md-8 mb-7">
        <DnsMap />
      </div>
      <div class="col-md-4 mb-7">
        <Card>
          <div class="dns-info">
            <div class="title">{{ $t('dns.infoTitle') }}</div>

            <ul class="list">
              <li class="list-item">
                <div class="icon"><i class="fas fa-star"></i></div>
                <div class="list-item-content">
                  <h3 class="list-item-content-title">
                    {{ $t('dns.alwaysONPluscloudsName') }}
                  </h3>
                  <p>{{ $t('dns.alwaysONPlusclouds') }}</p>
                </div>
              </li>
              <li class="list-item">
                <div class="icon"><i class="fas fa-star"></i></div>
                <div class="list-item-content">
                  <h3 class="list-item-content-title">
                    {{ $t('dns.effectiveSecurityName') }}
                  </h3>
                  <p>{{ $t('dns.effectiveSecurity') }}</p>
                </div>
              </li>
              <li class="list-item">
                <div class="icon"><i class="fas fa-star"></i></div>
                <div class="list-item-content">
                  <h3 class="list-item-content-title">
                    {{ $t('dns.highStableName') }}
                  </h3>
                  <p>{{ $t('dns.highStable') }}</p>
                </div>
              </li>
            </ul>

            <div class="go-to-community-message">
              <i class="fas fa-users"></i>
              <span v-html="$t('dns.communityLink')"></span>
            </div>
          </div>
        </Card>
      </div>
    </div>

    <!-- <div class="row info-content">
      <div class="col-md-4 mb-5 item">
        <Card>
          <div class="title">
            {{ $t('dns.alwaysON') }}
          </div>
          <p>{{ $t('dns.alwaysONContent') }}</p>
          <div class="background-icon">
            <i class="fas fa-battery-bolt"></i>
          </div>
        </Card>
      </div>
      <div class="col-md-4 mb-5 item">
        <Card>
          <div class="title">
            {{ $t('dns.effectiveSecurityTitle') }}
          </div>
          <p>{{ $t('dns.effectiveSecurityContent') }}</p>
          <div class="background-icon">
            <i class="fas fa-cog"></i>
          </div>
        </Card>
      </div>
      <div class="col-md-4 mb-5 item">
        <Card>
          <div class="title">
            {{ $t('dns.highStableTitle') }}
          </div>
          <p>{{ $t('dns.highStableContent1') }}</p>
          <p>{{ $t('dns.highStableContent2') }}</p>
          <div class="background-icon">
            <i class="fas fa-dumbbell"></i>
          </div>
        </Card>
      </div>
    </div> -->

    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      @click="clickField"
      detailUrl="/networking/domain-name-service"
      :moduleName="`servers.advancedDns`"
      :moduleCreateEvent="`subHeaderDetailOpen`"
      :moduleSearch="search"
    >
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:item.running="{ item }">
        <div
          v-if="
            item.dnsService && item.dnsService.data && item.dnsService.data.name
          "
        >
          {{ item.dnsService.data.name }}
        </div>
        <div v-else>
          <div
            class="errorMessages d-flex align-items-center"
            @click="enableDNS(item)"
          >
            <i class="fas fa-exclamation-triangle error-icon" />
            <p class="ml-2">{{ $t('global.enableService') }}</p>
          </div>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <b-dropdown
          class="actions-button nomaxh"
          variant="dark"
          :text="$t('global.actions')"
        >
          <template v-if="!item.dns_service_id">
            <b-dropdown-item @click.native="enableDNS(item)">{{
              $t('dns.enableDNSService')
            }}</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
          </template>
          <b-dropdown-item
            class="dropdownAlertLabel"
            @click.native="terminateOperation(item)"
            >{{ $t('servers.terminateDomain') }}</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </List>

    <!-- Create Popup -->
    <DetailModal
      :title="$t('servers.newDomain')"
      :show="showDetail"
      @confirm="confirmModal()"
      @closeDetail="closeDetail()"
      :resetForm="resetForm"
    >
      <DomainCreate
        :confirmModal="confirmCreate"
        :detailDomain="detailDomain"
        @resetDetailForm="resetDetailForm"
        v-if="showDetail"
      />
    </DetailModal>
    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />
  </div>
</template>

<script>
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'DNS',
  data() {
    return {
      search: '',
      filters: '',
      showDetail: false,
      loading: false,
      confirmCreate: false,
      resetForm: false,
      header: [
        {
          text: 'servers.domainName',
          value: 'name',
          size: '2fr',
          clicked: true,
        },
        {
          text: 'servers.runningUnderService',
          value: 'running',
          size: '2fr',
        },
        { text: 'global.actions', value: 'action' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
      detailDomain: '',
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'servers.advancedDns',
        route: '/networking/domain-name-service',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'global.networking',
        },
        {
          title: 'servers.advancedDns',
          route: '/networking/domain-name-service',
        },
      ],
      searchPlaceholder: 'servers.searchForDomain',
      detailPlaceholder: 'servers.newDomain',
    })

    EventBus.$on(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$on(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$off(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  methods: {
    listenersubHeaderSearch(payload) {
      this.search = payload
      this.getList()
    },
    listenersubHeaderDetailOpen(payload) {
      this.showDetail = payload
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `domains?include=dnsService&position=id|desc&page=${
        current_page ? current_page : 1
      }`

      if (this.search) $query += `&name=${this.search}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    closeDetail() {
      this.showDetail = false
      this.detailDomain = ''
    },
    clickField(item) {
      this.$router.push('/networking/domain-name-service/' + item.id)
    },
    terminateOperation(item) {
      this.deleteOperationUrl = `domains/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
    enableDNS(item) {
      this.showDetail = true
      setTimeout(() => {
        this.detailDomain = item.name
      }, 200)
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    DomainCreate: () => import('@/components/forms/DomainCreate'),
    DnsMap: () => import('@/components/DnsMap'),
  },
}
</script>

<style lang="scss">
.dns-info {
  .title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: #4a4b68;
    margin-bottom: 14px;
  }

  .list {
    list-style: none;
    margin-bottom: 0;
    padding-bottom: 20px;
    border-bottom: 1px solid #eeeff3;

    &-item {
      display: flex;
      column-gap: 10px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .icon {
        position: relative;
        width: 32px;
        height: 32px;
        min-width: 32px;
        min-height: 32px;
        background: #00baf2;
        border-radius: 100%;

        i {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 12px;
          line-height: 12px;
          color: #ffffff;
        }
      }

      &-content {
        &-title {
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
          color: #b5b5c3;
        }

        p {
          font-size: 14px;
          line-height: 21px;
          font-weight: 500;
          color: #4a4b68;
        }
      }
    }
  }

  .go-to-community-message {
    display: flex;
    column-gap: 10px;
    margin-top: 20px;

    i {
      font-size: 20px;
      line-height: 20px;
      color: #4a4b68;
    }

    span {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #4a4b68;

      a {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        text-decoration-line: underline;
        color: #4a4b68;

        &:hover {
          text-decoration-line: underline !important;
        }
      }
    }
  }
}

.info-content {
  .item {
    position: relative;

    .title {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 30px;
      color: #b5b5c3;
      position: relative;
      z-index: 1;
    }

    p {
      font-weight: 600;
      font-size: 17px;
      line-height: 25px;
      margin-bottom: 14px;
      color: #464e5f;
      position: relative;
      z-index: 1;

      &:last-child {
        margin-bottom: 0px;
      }
    }

    .background-icon {
      position: absolute;
      top: 20px;
      right: 30px;
      z-index: 0;

      i {
        font-size: 132px;
        line-height: 132px;
        color: #f6f7f9;
      }
    }
  }
}
.errorMessages {
  cursor: pointer;
  .error-icon {
    color: #f64e60;
  }
}
</style>
